import { render } from "./ShipDetails.vue?vue&type=template&id=720510ae&scoped=true"
import script from "./ShipDetails.vue?vue&type=script&lang=js"
export * from "./ShipDetails.vue?vue&type=script&lang=js"

import "./ShipDetails.vue?vue&type=style&index=0&id=720510ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720510ae"]])

export default __exports__